// Strings for release 4c frontend (0022/0023): the head of school's
// "Something else" curation screen (replacing 0021's platform-admin,
// per-national-grade panel — see r4bStrings.ts for the concern.* vocabulary
// itself) and the platform admin's school help links (Wilma, helpline).
// Merged into STRINGS in strings.ts. Finnish and Swedish are drafts
// pending native-speaker review, same as every other release.

type Shape<T> = { [K in keyof T]: T[K] extends (...a: infer A) => string ? (...a: A) => string : string };

export const r4cEn = {
  // Head nav + page: "Something else" curation, per school grade.
  'hs.navSettings': 'Settings',
  'r4c.hse.title': '“Something else” options',
  'r4c.hse.hint': 'What students can pick after “Something else” on the check-in, for each grade. “I’d rather not say” can’t be removed.',
  'r4c.hse.grade': 'Grade',
  'r4c.hse.noGrades': 'Ask your primary head of school to set this up — only they can choose which grades to curate.',
  'r4c.hse.draft': 'Draft wording, pending a counsellor review.',
  'r4c.hse.saved': 'Saved.',

  // Platform admin: school help links (support mode), warning-level
  // checklist items (D12: never a blocker for going Live).
  'r4c.help.title': 'Help links',
  'r4c.help.hint': 'Shown to students in the help strip on every check-in screen, alongside the safety-net message. A link the school hasn’t set is simply not shown — neither is ever required.',
  'r4c.help.wilma': 'Wilma link',
  'r4c.help.wilmaHint': 'Where “Message the counsellor in Wilma” points.',
  'r4c.help.name': 'Helpline name',
  'r4c.help.contact': 'Helpline contact',
  'r4c.help.contactHint': 'A phone number (as tel:+358…) or a web address.',
  'pa.ckWilmaLink': 'Wilma link',
  'pa.ckHelpline': 'Helpline',
};

export type R4cStrings = Shape<typeof r4cEn>;

export const r4cFi: R4cStrings = {
  'hs.navSettings': 'Asetukset',
  'r4c.hse.title': '”Jokin muu” -vaihtoehdot',
  'r4c.hse.hint': 'Mitä oppilas voi valita ”Jokin muu” -kohdan jälkeen kyselyssä, luokka-asteittain. ”En halua sanoa” ei voi poistaa.',
  'r4c.hse.grade': 'Luokka-aste',
  'r4c.hse.noGrades': 'Pyydä koulun rehtoria tekemään tämä — vain hän voi valita, mitä luokka-asteita muokataan.',
  'r4c.hse.draft': 'Luonnosteksti, odottaa kuraattorin tarkistusta.',
  'r4c.hse.saved': 'Tallennettu.',

  'r4c.help.title': 'Apulinkit',
  'r4c.help.hint': 'Näytetään oppilaille apuosiossa jokaisessa kyselynäkymässä turvaviestin vierellä. Linkki, jota koulu ei ole asettanut, ei näy — kumpikaan ei ole pakollinen.',
  'r4c.help.wilma': 'Wilma-linkki',
  'r4c.help.wilmaHint': 'Minne ”Viesti kuraattorille Wilmassa” ohjaa.',
  'r4c.help.name': 'Auttavan puhelimen nimi',
  'r4c.help.contact': 'Auttavan puhelimen yhteystieto',
  'r4c.help.contactHint': 'Puhelinnumero (muodossa tel:+358…) tai verkko-osoite.',
  'pa.ckWilmaLink': 'Wilma-linkki',
  'pa.ckHelpline': 'Auttava puhelin',
};

export const r4cSv: R4cStrings = {
  'hs.navSettings': 'Inställningar',
  'r4c.hse.title': '”Något annat”-alternativ',
  'r4c.hse.hint': 'Vad eleven kan välja efter ”Något annat” i enkäten, per årskurs. ”Jag vill inte säga” kan inte tas bort.',
  'r4c.hse.grade': 'Årskurs',
  'r4c.hse.noGrades': 'Be skolans rektor göra detta — endast rektorn kan välja vilka årskurser som redigeras.',
  'r4c.hse.draft': 'Utkasttext, väntar på kuratorsgranskning.',
  'r4c.hse.saved': 'Sparat.',

  'r4c.help.title': 'Hjälplänkar',
  'r4c.help.hint': 'Visas för eleverna i hjälpavsnittet på varje enkätvy, bredvid stödmeddelandet. En länk skolan inte har angett visas helt enkelt inte — ingen av dem är obligatorisk.',
  'r4c.help.wilma': 'Wilma-länk',
  'r4c.help.wilmaHint': 'Vart ”Skicka meddelande till kuratorn i Wilma” leder.',
  'r4c.help.name': 'Stödtelefonens namn',
  'r4c.help.contact': 'Stödtelefonens kontaktuppgift',
  'r4c.help.contactHint': 'Ett telefonnummer (som tel:+358…) eller en webbadress.',
  'pa.ckWilmaLink': 'Wilma-länk',
  'pa.ckHelpline': 'Stödtelefon',
};
